/**
 * Design Tokens - Spacing
 *
 * 4-px base unit (0.25rem). Matches common design system conventions.
 * Use these tokens for margin, padding, gap, and layout sizing.
 */

export const spacing = {
  px: '1px',
  0: '0',
  0.5: '0.125rem',  //  2px
  1: '0.25rem',   //  4px
  1.5: '0.375rem',  //  6px
  2: '0.5rem',    //  8px
  2.5: '0.625rem',  // 10px
  3: '0.75rem',   // 12px
  3.5: '0.875rem',  // 14px
  4: '1rem',      // 16px
  5: '1.25rem',   // 20px
  6: '1.5rem',    // 24px
  7: '1.75rem',   // 28px
  8: '2rem',      // 32px
  9: '2.25rem',   // 36px
  10: '2.5rem',    // 40px
  11: '2.75rem',   // 44px
  12: '3rem',      // 48px
  14: '3.5rem',    // 56px
  16: '4rem',      // 64px
  18: '4.5rem',    // 72px  - nav height
  20: '5rem',      // 80px
  24: '6rem',      // 96px
  28: '7rem',      // 112px
  32: '8rem',      // 128px
  36: '9rem',      // 144px
  40: '10rem',     // 160px
  48: '12rem',     // 192px
  56: '14rem',     // 224px
  64: '16rem',     // 256px
} as const;

/**
 * Semantic spacing aliases - use these for layout intent
 * rather than raw numbers.
 */
export const layout = {
  navHeight: '72px',
  maxWidth: '1280px',
  sectionPaddingY: '100px',
  sectionPaddingYMd: '64px',
  sectionPaddingYSm: '44px',
  containerPaddingX: '24px',
  containerPaddingXSm: '16px',
  cardPadding: '32px',
  cardPaddingLg: '40px',
  cardPaddingSm: '20px',
} as const;
